import { withLDProvider } from 'launchdarkly-react-client-sdk';

export default function withLaunchDarkly(WrappedComponent) {
  const alefUser = JSON.parse(localStorage.getItem('alef_user'));
  const id = alefUser ? alefUser.user.uuid : '';
  const email = alefUser ? alefUser.user.email : '';
  const user =
    (window &&
      window.AssignmentAppConfig &&
      window.AssignmentAppConfig.LAUNCH_DARKLY.LAUNCH_DARKLY_CLIENT_ID) ||
    '';

  const configOptions = {
    fetchGoals: false,
    diagnosticOptOut: true,
  };

  const useProxy =
    (window &&
      window.AssignmentAppConfig &&
      window.AssignmentAppConfig.LAUNCH_DARKLY.useProxy) ||
    '';

  if (useProxy) {
    configOptions.streamUrl = '/launchdarkly/streaming';
    configOptions.baseUrl = '/launchdarkly';
    configOptions.eventsUrl = '/launchdarkly/events';
  }
  return withLDProvider({
    clientSideID: user,
    context: {
      kind: 'user',
      key: id,
      email,
    },
    options: configOptions,
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  })(WrappedComponent);
}
